module.exports = __webpack_public_path__ + "media/images/flags/rs-4bf971be2682587e3bf9a422af74de1f.svg";